import map from 'lodash/map';

import { TAdvertising, TContentBlock } from '@r1-frontend/api-domru/api-content/v1/page/view';

export type TPreparedContentBlocks = {
    id: number,
    title: string,
    desc: string,
    action: string,
    colorText: string,
    img: string,
    imgWebp: string,
    textButton: string,
    bgColor: string,
    advertising?: TAdvertising,
    alias: number,
}

export const getPreparedContentBlocks = (data: Record<string, TContentBlock>): TPreparedContentBlocks[] => {
    return map(data, block => ({
        id: block.id,
        title: block.title,
        desc: block.subtitle,
        action: block.link,
        colorText: block.text_color,
        img: block.image,
        imgWebp: block.image_webp,
        textButton: block.button_text,
        bgColor: block.bg_color,
        advertising: block.advertising,
        alias: block.alias,
    }));
};
